export default "__VITE_ASSET__40e3229f__"